import React, { useState } from "react";
import { FaUserPlus, FaEye, FaEyeSlash } from "react-icons/fa";
import MessageBar, { config, errorNotify, successNotify } from "../../../utils/helper";
import { authorizedPost } from "../../../Config/networkWithToken";
import { useFormik } from "formik";
import configuration from "../../../Config/configuration";

const CoordinatorCreation = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isButtonLoad, setIsButtonLoad] = useState(false);

  const validate = (values) => {
    const errors = {};
    if (!values.name.trim()) {
      errors.name = "Name is required";
    }
    if (!values.email.trim()) {
      errors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = "Invalid email address";
    }
    if (!values.password.trim()) {
      errors.password = "Password is required";
    } else if (values.password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }
    return errors;
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
    },
    validate,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      name: values.name,
      email: values.email,
      password: values.password,
      role: "coordinator",
    };

    try {
      setIsButtonLoad(true);
      const res = await authorizedPost(
        configuration.apis.adminRegister,
        data,
        config,
      );
      if (res?.data?.status) {
        successNotify(res?.data?.message || "Coordinator created successfully!");
        formik.resetForm();
      } else {
        if (res?.data?.message?.toLowerCase().includes("email already exist")) {
          errorNotify("Email already exists. Please use another email.");
        } else {
          errorNotify(res?.data?.message || "Failed to create coordinator");
        }
      }
    } catch (err) {
      errorNotify("Unexpected error, please try again");
    }
    setIsButtonLoad(false);
  };

  return (
    <div className="font-Poppins via-orange-100 flex min-h-screen items-center justify-center bg-gradient-to-br from-yellow-100 via-white to-yellow-100 p-4">
      <div className="w-[90%] rounded-2xl bg-white p-8 shadow-2xl md:w-[80%]">
        <div className="mb-6 flex items-center justify-center gap-2">
          <FaUserPlus className="h-6 w-6 text-[#F6AF42]" />
          <h2 className="text-2xl font-bold text-gray-800">Create Coordinator</h2>
        </div>

        <form onSubmit={formik.handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-semibold text-gray-700">
              Name
            </label>
            <input
              type="text"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter coordinator name"
              className={`mt-2 w-full rounded-lg border ${
                formik.errors.name && formik.touched.name
                  ? "border-red-500"
                  : "border-gray-300"
              } p-3 text-gray-700 shadow-sm focus:border-[#F6AF42] focus:outline-none focus:ring-2 focus:ring-[#F6AF42]/40`}
            />
            {formik.errors.name && formik.touched.name && (
              <p className="mt-1 text-xs text-red-500">{formik.errors.name}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter coordinator email"
              className={`mt-2 w-full rounded-lg border ${
                formik.errors.email && formik.touched.email
                  ? "border-red-500"
                  : "border-gray-300"
              } p-3 text-gray-700 shadow-sm focus:border-[#F6AF42] focus:outline-none focus:ring-2 focus:ring-[#F6AF42]/40`}
            />
            {formik.errors.email && formik.touched.email && (
              <p className="mt-1 text-xs text-red-500">{formik.errors.email}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700">
              Password
            </label>
            <div className="relative mt-2">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter password"
                className={`w-full rounded-lg border ${
                  formik.errors.password && formik.touched.password
                    ? "border-red-500"
                    : "border-gray-300"
                } p-3 text-gray-700 shadow-sm focus:border-[#F6AF42] focus:outline-none focus:ring-2 focus:ring-[#F6AF42]/40`}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
              >
                {showPassword ? (
                  <FaEye className="h-5 w-5" />
                ) : (
                  <FaEyeSlash className="h-5 w-5" />
                )}
              </button>
            </div>
            {formik.errors.password && formik.touched.password && (
              <p className="mt-1 text-xs text-red-500">
                {formik.errors.password}
              </p>
            )}
          </div>
          <button
            type="submit"
            disabled={isButtonLoad}
            className={`w-full rounded-lg bg-[#F6AF42] px-4 py-3 font-semibold text-white shadow-md transition duration-300 hover:bg-[#e39e36] focus:outline-none focus:ring-4 focus:ring-[#F6AF42]/40 ${
              isButtonLoad && "cursor-not-allowed opacity-70"
            }`}
          >
            {isButtonLoad ? "Creating..." : "Create Coordinator"}
          </button>
        </form>
      </div>
      <MessageBar />
    </div>
  );
};

export default CoordinatorCreation;
